import { notification } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const Delete = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.STORE);
  const DELETE = t("DELETE", { returnObjects: true });
  const navigate = useNavigate();
  const { id } = useParams();
  const [visible, setVisible] = useState(true);
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.STORES.LIST.path);
  const [deleteStore] = useMutation(graphql.mutations.DELETE_STORE, {
    refetchQueries: [
      {
        query: graphql.queries.STORES,
        awaitRefetchQueries: true,
        variables: INITIAL_VALUES,
      },
    ],
    onCompleted: () => {
      setVisible(false);
      navigate(SCREENS.PRIVATE.ADMIN.STORES.LIST.path, { replace: true });
    },
    onError: () => {
      setVisible(false);
      navigate(SCREENS.PRIVATE.ADMIN.STORES.LIST.path, { replace: true });
      notification.error({ message: DELETE.ERROR });
    },
  });
  const onSubmit = () => {
    return deleteStore({
      variables: {
        where: {
          id,
        },
      },
    });
  };
  return <View onSubmit={onSubmit} cancel={cancel} visible={visible} />;
};

export default Delete;
